export function progressBarStyle(): Record<string, string | number> {
  return {
    position: 'absolute',
    bottom: 0
  };
}

export function brandBarStyle(): Record<string, string | number> {
  return {
    maxWidth: '100px'
  };
}
